<template>
<div>
  <button @click="encrypt('15367978596','mq#cUX@d')">userrname</button>
  <button @click="encrypt('a1234565','mq#cUX@d')">passwd</button>
</div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  name: "Demo",
  methods: {
    // 加密
    encrypt(word, keyStr) {
      keyStr = keyStr ? keyStr : "mq#cUX@d";
      let key = CryptoJS.enc.Utf8.parse(keyStr);
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.DES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      alert(encrypted.ciphertext.toString())
      return encrypted.ciphertext.toString();
    },
    // 解密
    decrypt(word, keyStr) {
      keyStr = keyStr ? keyStr : "absoietlj32fai12";
      var key = CryptoJS.enc.Utf8.parse(keyStr);
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
  }
}
</script>

<style scoped>

</style>
